/*
* author ivanm
*/
define(function (require) {
    "use strict";
 
    var LE = require("app");
    var template = require("registration-templates/registrationSomethingWentWrongView.tmpl");
    var Button = require("ui/button/Button");
    var RegistrationFailedCreateAccountView = {};
 
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {
        RegistrationFailedCreateAccountView = Marionette.ItemView.extend({
 
            template: template,
 
            ui: {
                registrationSignUpPageLink: ".sign-up-page-link",
                errorCode: ".error-code"
            },
            initialize: function (options) {
                this.options = options;
            },
 
            onRender:function () {
                var that = this;

                if(this.options && this.options.errorCode) {
                    this.ui.errorCode.text(LE.translator.translate("LERegistration.ErrorCode").replace("{0}",  this.options.errorCode));
                } else {
                    this.ui.errorCode.text(LE.translator.translate("LERegistration.ErrorCode").replace("{0}",  100));
                }
                var returnLink = this.options.returnPage;

                this.button = new Button({
                    el:this.ui.registrationSignUpPageLink,
                    permutation:Button.PERMUTATION.BLUELINK,
                    initState:Button.STATES.ENABLED,
                    onClick : function(ev){
                        LE.router.navigate(
                            returnLink,
                            {
                                language: that.model.attributes.language,
                                origin: that.model.attributes.origin,
                                tier: that.model.attributes.tier,
                                frequency: that.model.attributes.frequency
                            }
                        );
                    }
                }).render();
            }
        });
    });
    return RegistrationFailedCreateAccountView;
});
 
 
